<template>
  <section class="city">
    <div class="container">
      <a-typography-title :level="1">
        社区城市管理者
      </a-typography-title>
      <a-typography-paragraph>
        社区开发者来自北京、上海、广州、深圳、杭州、青岛等城市，欢迎申请成为城市管理员。
      </a-typography-paragraph>
      <div class="box_map">
        <div class="map_1">
          <img alt=""
               :src="file.ImageMap_1" />
          <div v-for="(item,index) in expand.mapList"
               class="box_position" :class="[{max:item.name.length>2,leader:item.leader},`i_${index+1}`]"
               :style="{top:`${item.y}%`,left:`${item.x}%`}">
            {{ item.name }}
            <a-popover trigger="hover">
              <template #content>
                <div class="popover_community_city_map">
                  <a-typography-title :level="5">
                    {{ item.name }}
                  </a-typography-title>
                  <div v-if="item.leader" class="l">
                    负责人：<span>{{ item.leader }}</span>
                  </div>
                  <div v-else class="qr">
                    <p>
                      扫码添加小助手，<br>
                      回复“<span>城市大使</span>”<br>
                      申请成为城市大使。
                    </p>
                  </div>
                </div>
              </template>
              <i />
            </a-popover>
          </div>
        </div>
        <img class="map_2" alt=""
             :src="file.ImageMap_2" />
      </div>
      <div class="box_text">
        <a-typography-title :level="5">
          你能得到什么？
        </a-typography-title>
        <p v-for="item in expand.getList">
          {{ item }}
        </p>
      </div>
      <div class="box_text">
        <a-typography-title :level="5">
          你需要做些什么？
        </a-typography-title>
        <p v-for="item in expand.doList">
          {{ item }}
        </p>
      </div>
      <div class="box_click">
        点击申请成为城市大使
      </div>
      <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_1"
                  @click="$Store.Page().openModal('modalQR', 'cityAmbassador')">
          点击申请
        </a-button>
      </a-space>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';
import ImageMap_1 from '@resource/image/page/community/city_map_1.png';
import ImageMap_2 from '@resource/image/page/community/city_map_2.png';

export default {
  name: 'community_city',
  data(): DataInterface {
    return {
      file: {
        ImageMap_1,
        ImageMap_2
      },
      expand: {
        mapList: [
          {
            name: '乌鲁木齐',
            x: 19,
            y: 37
          },
          {
            name: '北京',
            x: 57,
            y: 47
          },
          {
            name: '青岛',
            x: 62,
            y: 58,
            leader: 'sdaulibin'
          },
          {
            name: '西安',
            x: 47,
            y: 64
          },
          {
            name: '武汉',
            x: 54,
            y: 73
          },
          {
            name: '合肥',
            x: 58,
            y: 70
          },
          {
            name: '上海',
            x: 65,
            y: 70
          },
          {
            name: '杭州',
            x: 62,
            y: 76,
            leader: 'zhuyaguang'
          },
          {
            name: '广州',
            x: 53,
            y: 92
          },
          {
            name: '东莞',
            x: 55,
            y: 90
          },
          {
            name: '深圳',
            x: 57,
            y: 92
          }
        ],
        getList: [
          '拥有开源社区纪念品和城市大使头衔，正式与星汉未来开源团队建立关系',
          '直接对接星汉未来开源团队，优先获取最新的技术培训、物料及最快速的技术支持',
          '不定期与星汉未来开源团队进行线上或线下沟通，与行业资深专家面对面交流'
        ],
        doList: [
          '在当地担任发言人或保持活跃，与当地高校、IT协会等单位组织保持联系',
          '组织当地社区开发者聚会，包括不限于技术Meetup、户外活动等',
          '使用星汉未来开源产品尽情发挥你的创造力',
          '与星汉未来开源技术团队一起，用技术和创新影响更多同学'
        ]
      }
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/community/';

.bgPosition() {
  .bg('@{image}city_position.png', 67px, 58px);
}

.creatAnimation(am_info_item, {
  0% {
    opacity: 0.5;
    .transform(translateY(0));
  }
  50% {
    opacity: 1;
    .transform(translateY(-10%));
  }
  100% {
    opacity: 0.5;
    .transform(translate(0));
  }
});

.city {
  overflow: hidden;
  position: relative;
  z-index: 0;
  padding: 0 @padding;
  background: @color_7;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

div.ant-typography {
  margin: @margin_mo 0 0;
  .font(center, @text+@line, @color_13, @text);
}

.box_map {
  position: relative;
  max-width: 1000px;
  margin: @margin_mo auto 0;
  
  img {
    display: block;
  }
  
  .map_1 {
    overflow: hidden;
    
    img {
      float: left;
      max-width: 82%;
    }
    
    .box_position {
      display: block;
      .center();
      width: 40px;
      .font(center, 14px, @color_black, 14px, true);
      //background: fade(@color_white, 50);
      
      .loop(@i) when (@i<=11) {
        &.i_@{i} {
          i {
            .animation(am_info_item 5s (-1+@i)*0.3s ease infinite forwards);
          }
        }
        .loop(@i+1);
      }
      .loop(1);
      
      &.max {
        width: 80px;
      }
      
      &.leader {
        i {
          top: -57px;
          width: 41px;
          height: 50px;
          background-position: 0 0;
        }
      }
      
      &:hover {
        &::before {
          opacity: 0.5;
        }
      }
      
      &::before {
        content: '';
        display: block;
        .position(top, -8px);
        width: 20px;
        height: 7px;
        margin: 0 auto;
        .bgPosition();
        background-position: -43px -30px;
        opacity: 0;
        .transform(scale(0.7));
        .transition(opacity @time);
      }
      
      i {
        display: block;
        .position(top, -35px);
        width: 24px;
        height: 28px;
        margin: 0 auto;
        .bgPosition();
        background-position: -43px 0;
        opacity: 0.5;
        cursor: pointer;
      }
    }
  }
  
  .map_2 {
    .position(absolute, auto, 0, 0, auto);
    max-width: 24.1%;
  }
}

.box_text {
  position: relative;
  padding: 20px 40px;
  margin: @margin_mo 0 0;
  background: @color_white;
  border: 1px solid @color_15;
  border-radius: 5px;
  
  &:nth-child(4) {
    p::before {
      @scale: 0.5;
      top: 5px;
      width: 16px;
      height: 16px;
      .bg('@{image}path_decorate.png', 90px*@scale, 56px*@scale);
      background-position: -58px*@scale -24px*@scale;
    }
  }
  
  &:nth-child(5) {
    p::before {
      top: 10px;
      left: 5px;
      width: 6px;
      height: 6px;
      background: @color_6;
    }
  }
  
  h5.ant-typography {
    margin: 0;
    .font(left, @title_sub, @color_12, @title_sub, true);
  }
  
  p {
    position: relative;
    padding-left: 30px;
    margin: 0;
    .font(justify, @text+@line, @color_13, @text);
    
    &:nth-child(2) {
      margin: 15px 0 0;
    }
    
    &::before {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      margin: auto 0;
      border-radius: 50%;
    }
  }
}

.box_click {
  margin: @margin 0 0;
  .font(center, @text, @color_13, @text);
}

.ant-space {
  margin: @margin_mo 0 0;
}

@media screen and (max-width: -1px+@grid_md) {
  .city {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo, @color_12, @title_mo, true);
  }
  
  div.ant-typography {
    .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
  }
  
  .box_map {
    .map_1 {
      .box_position {
        .transform(translate(-50%, -50%) scale(0.45));
      }
    }
  }
  
  .box_text {
    padding: 20px;
    
    h5.ant-typography {
      .font(left, @title_sub_mo, @color_12, @title_sub_mo, true);
    }
  }
  
  .box_click {
    margin: @margin_mo 0 0;
  }
}
</style>

<style lang="less" rel="stylesheet/less">
@import '@resource/css/_global.less';

@imagePublic: '@{src_image}public/';
@image: '@{src_image}page/community/';

.popover_community_city_map {
  h5.ant-typography {
    position: relative;
    width: 240px;
    padding: 0 0 10px 25px;
    margin: 0;
    .font(left, @text, @color_13, @text, true);
    border-bottom: 1px solid @color_15;
    
    &::before {
      content: '';
      display: block;
      .position(absolute, -1px, auto, auto, 0);
      width: 13px;
      height: 19px;
      .bg('@{image}city_position.png', 67px, 58px);
      background-position: -43px -39px;
    }
  }
  
  .l,
  .qr {
    margin: 10px 0 0;
    .font(left, @text+@line, @color_13, @text);
  }
  
  .l {
    span {
      font-weight: bold;
    }
  }
  
  .qr {
    overflow: hidden;
    
    &::before {
      content: '';
      float: left;
      display: block;
      margin-right: 10px;
      .bg('@{imagePublic}qr_assistant.jpg', 80px, 80px, true);
    }
    
    p {
      span {
        color: @color_6;
      }
    }
  }
}
</style>